module.exports = __webpack_public_path__ + "img/account_1000.01675629.jpg";